import { render, staticRenderFns } from "./service.vue?vue&type=template&id=1b6c904a&scoped=true&"
import script from "./service.vue?vue&type=script&lang=js&"
export * from "./service.vue?vue&type=script&lang=js&"
import style0 from "./service.vue?vue&type=style&index=0&id=1b6c904a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6c904a",
  null
  
)

export default component.exports